/**
 * Organization Service
 * API calls for organization management
 */

import api from './api';

export const organizationService = {
  // Get all organizations with filters
  getOrganizations: (params = {}) => api.get('/organizations', params),

  // Get single organization
  getOrganization: (id) => api.get(`/organizations/${id}`),

  // Create organization
  createOrganization: (orgData) => api.post('/organizations', orgData),

  // Update organization
  updateOrganization: (id, orgData) => api.put(`/organizations/${id}`, orgData),

  // Delete organization
  deleteOrganization: (id) => api.delete(`/organizations/${id}`),

  // Get organization usage stats
  getUsage: (id) => api.get(`/organizations/${id}/usage`),

  // Update subscription
  updateSubscription: (id, subscriptionData) => api.put(`/organizations/${id}/subscription`, subscriptionData),

  // Check if email exists
  checkEmail: (email, excludeId) => api.post('/organizations/check-email', { email, excludeId }),

  // Suspend organization
  suspendOrganization: (id, reason) => api.put(`/organizations/${id}/suspend`, { reason }),

  // Reactivate suspended organization
  reactivateOrganization: (id) => api.put(`/organizations/${id}/reactivate`),

  // Extend plan validity (super-admin only). payload: { addedDays?, newEndDate?, reason }
  extendPlan: (id, payload) => api.put(`/organizations/${id}/extend-plan`, payload),

  // Set/clear the admin participant-cap override (super-admin only).
  // payload: { maxParticipants: number|null } — null resets to the plan default.
  setParticipantOverride: (id, maxParticipants) =>
    api.put(`/organizations/${id}/participant-override`, { maxParticipants }),
};

export default organizationService;
